<div class="column">
  @switch (status()) {
    @case ('idle') {
      @let _title = 'help_modal.TEXT.All_systems';
      @let _content = 'help_modal.TEXT.Run_a_quick_test';
      @let _icon = 'icons icons-check-circle';

      <ng-container *ngTemplateOutlet="messageTemplate; context: { title: _title, content: _content, icon: _icon }"/>
    }

    @case ('running') {
      @let _title = 'help_modal.TEXT.Diagnostics_in_progress';
      @let _content = 'help_modal.TEXT.Results_will_appear';
      @let _icon = 'icons icons-hourglass';

      <ng-container *ngTemplateOutlet="messageTemplate; context: { title: _title, content: _content, icon: _icon }"/>
    }

    @case ('success') {
      @let _title = 'help_modal.TEXT.All_systems';
      @let _content = 'help_modal.TEXT.Diagnostics_complete';
      @let _icon = 'icons icons-check-circle';

      <ng-container *ngTemplateOutlet="messageTemplate; context: { title: _title, content: _content, icon: _icon }"/>
    }

    @case ('failed') {
      @for (issue of issues(); track issue.title) {
        <div class="row">
          @if ($index === 0) {
            <i class="icons icons-exclamation-triangle"></i>
          }

          <span class="label">{{ issue.title | translate }}</span>

          @if ($index === 0) {
            <button
              [ideals-tooltip]="'help_modal.Tooltips.Copy_issues' | translate"
              [idealsClipboard]="issuesText()"
              type="button"
              (clipboardCopy)="onCopyToClipboard()"
            >
              <i class="icons icons-copy"></i>
            </button>
          }
        </div>

        <p class="text">{{ issue.description | translate }}</p>
        <p class="text">{{ issue.details }}</p>

        @if (issue.cta) {
          <p class="text">{{ issue.cta | translate }}</p>
        }
      }
    }
  }
</div>

<div class="actions">
  @if (status() === 'idle') {
    <button
      class="ideals-btn btn-outline"
      type="button"
      (click)="runDiagnostic.emit()"
      data-ideals="run-diagnostic"
    >
      {{ 'help_modal.CTA.Run_diagnostic' | translate }}
    </button>
  } @else if (status() === 'running') {
    <button
      class="ideals-btn btn-outline"
      type="button"
      data-ideals="run-diagnostic"
    >
      {{ 'help_modal.TEXT.Processing' | translate }} 
    </button>
  } @else {
    <button
      class="ideals-btn reload-button"
      type="button"
      (click)="runDiagnostic.emit()"
      data-ideals="run-new-diagnostic"
    >
      <i class="icons icons-refresh"></i>
      {{ 'help_modal.TEXT.Run_new' | translate }}
    </button>

    <button
      class="ideals-btn btn-outline"
      type="button"
      (click)="downloadReport.emit()"
      data-ideals="download-report"
    >
      <i class="icons icons-download"></i>
      {{ 'common.BTN.Download_report' | translate }}
    </button>
  }
</div>

<ng-template
  #messageTemplate
  let-content="content"
  let-icon="icon"
  let-title="title"
>
  <div class="row">
    <i [class]="icon"></i>
    <span class="label">{{ title | translate }}</span>
  </div>

  <p class="text">{{ content | translate }}</p>
</ng-template>
